import { render, staticRenderFns } from "./updatePwd.vue?vue&type=template&id=d61e17ca&scoped=true"
import script from "./updatePwd.vue?vue&type=script&lang=js"
export * from "./updatePwd.vue?vue&type=script&lang=js"
import style0 from "./updatePwd.vue?vue&type=style&index=0&id=d61e17ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61e17ca",
  null
  
)

export default component.exports